import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { CoreConfigService } from '@core/services/config.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

import { CommunicationService } from '../../../../../services/communication.service';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-auth-register-v1',
  templateUrl: './auth-register-v1.component.html',
  styleUrls: ['./auth-register-v1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthRegisterV1Component implements OnInit {
  // Public
  public coreConfig: any;
  public loading: boolean;
  public token:string;
  public iframe = false;

  public inviteInfo:any;

  public inviteContent :any = [];
  public selectLocation;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {FormBuilder} _formBuilder
   * @param {Router} _routerLink

   */
  constructor(
    private _coreConfigService: CoreConfigService, 
    private _formBuilder: UntypedFormBuilder,
    private _route: ActivatedRoute,
    private _communicationService: CommunicationService,
    private _routerLink: Router
    ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }


  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    this.loading = true;

    // get return url from route parameters or default to '/'
    this.token = this._route.snapshot.queryParams['token'] || '/';
    // get return url from route parameters or default to '/'
    this.iframe = Boolean(this._route.snapshot.queryParams["iframe"]) || false;
    this._communicationService.getSelfInviteInfo(this.token)
    .pipe(first())
    .subscribe(
      
      data => {   
        if(this.iframe == true ){
          var url = data['link'] + '&iframe=true';
        }else{
          var url = data['link'];
        }

        location.replace(url);  

      },
      error => {
        this.loading = false;      
      }
    );

    



    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  openInvite(){
    var openInviteToken = <HTMLInputElement> document.getElementById('openInviteToken');    
    var link = window.location.href;     
    var goUrl = link.split('/page')[0] + '/pages/authentication/register-invite?token=' + openInviteToken.value;      
    if(this.iframe == true ){
      goUrl = goUrl + '&iframe=true';
    }
    window.open(goUrl, '_self');   
  }

  sendInvite(){

    Swal.fire({
      icon: 'info',
      title: 'Sending Invitation',
      html: '<div><p>We are sending the invite to '+ this.inviteContent.contact +' </P></div><div class="spinner-grow text-primary" style="width: 3rem; height: 3rem" role="status"><span class="sr-only">Loading...</span></div>',
      allowOutsideClick: function () {
        return !Swal.isLoading();
      }
    });

    var data = {
      info: {
        first_name: this.inviteContent.firstName,
        last_name: this.inviteContent.lastName,
        email: this.inviteContent.contact,  
        phone: this.inviteContent.phone,
      },
      token: this.token
    }          
    
    this._communicationService.sendSelfInvite(data).then(function (result: any) {
      var openInviteToken = <HTMLInputElement> document.getElementById('openInviteToken');    
      openInviteToken.value = result.token;
      
      
        var openInviteBtn = <HTMLInputElement> document.getElementById('openInviteBtn');    
        openInviteBtn.click();      


    },
    (error:any) =>{
      Swal.fire({
        icon: 'error',
        title: 'Invitation was not sent',
        text: error,
        showConfirmButton: false,
        allowOutsideClick: function () {
          return !Swal.isLoading();
        }
      });

      
    }
    );
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
